<template>
  <vs-card class="borderR">
    <vs-row id="center">
      <vs-list-header
        title="Total Manhour Worker"
        style="font-size: 18px"
        color="dark"
      ></vs-list-header>
      <vs-spacer />
      <vs-select v-model="select1" @change="dataChartasync" width="120px">
        <vs-select-item
          :key="index"
          :value="item"
          :text="item"
          v-for="(item, index) in options1"
        />
      </vs-select>
      <!-- <vs-button
        radius
        class="mr-2"
        color="#333f50"
        type="flat"
        @click="openPopupCreateManhourGraph"
        icon="mode_edit"
        align="right"
      ></vs-button>
      <vs-button
        radius
        class="mr-2"
        color="#333f50"
        type="flat"
        @click="setManhourGraph"
        icon="build"
        align="right"
      ></vs-button> -->
      <vs-button
        radius
        class="mr-2"
        color="#333f50"
        type="flat"
        @click="exportXLSX"
        icon="cloud_download"
        align="right"
      ></vs-button>
      <vs-button
        radius
        class="mr-2"
        color="#333f50"
        type="flat"
        @click="exportPDF"
        icon="picture_as_pdf"
      ></vs-button>
    </vs-row>
    <div ref="pdf">
      <BarChart :xValue="xValue" :yValue="yValue" style="height: 200px" />
    </div>
    <b-modal
      size="lg"
      ref="my-modal-createManhour"
      hide-footer
      title="Create Manhour"
    >
      <vs-row>
        <vs-col type="flex" vs-justify="center" vs-w="12">
          <label for="example-input">Target</label>
          <b-input
            v-model.number="targetValue"
            class="inputx"
            placeholder="target"
            style="border-radius: 15px"
          />
          <label for="example-input" class="mt-2">Choose a date</label>
          <datetime
            v-model="targetDatevalue"
            type="datetime"
            input-class="form-control"
            placeholder="YYYY/MM/DD H:i:s"
          ></datetime>
          <vs-alert
            :active.sync="alertDate"
            closable
            close-icon="close"
            color="danger"
          >
            Date is required
          </vs-alert>
        </vs-col>
      </vs-row>
      <vs-row class="mt-3">
        <vs-col
          type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
          class="text-right"
        >
          <vs-button
            @click="SaveCreateManhourGraph"
            color="primary"
            type="filled"
            class="mr-2"
            >Save</vs-button
          >
          <vs-button
            @click="ClosePopupCreateManhourGraph"
            color="grey"
            type="filled"
            >Cancel</vs-button
          >
        </vs-col>
      </vs-row>
    </b-modal>
    <b-modal
      size="lg"
      ref="my-modal-setManhour"
      hide-footer
      title="Set Manhour"
    >
      <vs-table :data="dataMergeManHour">
        <template slot="thead">
          <vs-th> Date Total Manhour </vs-th>
          <vs-th> Total Manhour </vs-th>
          <vs-th> Date Target Manhour </vs-th>
          <vs-th> Target Manhour </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.indoorTagManHour.date">
              {{ tr.indoorTagManHour.date }}
            </vs-td>
            <vs-td :data="tr.indoorTagManHour.manhour">
              {{ tr.indoorTagManHour.manhour }}
            </vs-td>
            <vs-td :data="tr.indoorManHour.date">
              {{ tr.indoorManHour.date }}
            </vs-td>
            <vs-td :data="tr.indoorManHour.target">
              <vs-input
                v-model="tr.indoorManHour.target"
                class="inputx"
                placeholder="target"
              />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-row class="mt-3">
        <vs-col
          type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
          class="text-right"
        >
          <vs-button
            @click="SaveSetManhourGraph"
            color="primary"
            type="filled"
            class="mr-2"
            >Save</vs-button
          >
          <vs-button
            @click="ClosePopupSetManhourGraph"
            color="grey"
            type="filled"
            >Cancel</vs-button
          >
        </vs-col>
      </vs-row>
    </b-modal>
  </vs-card>
</template>

<script>
import BarChart from "../../Overview/Syntec/BarChart.vue";
import moment from "moment";

import XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";

export default {
  components: {
    BarChart,
  },
  data() {
    return {
      options1: ["Day", "Week", "Month"],
      select1: "Day",
      selectLoop: 1,

      xValue: [],
      yValue: [],

      targetDatevalue: "",
      targetValue: 0,
      dataMergeManHour: [],
      resultIndoorManHour: [],
      resultIndoorTagManHour: [],
      totalManhorExport: [],
      totalManhour: [],
      totalWorker: [],
      dateManhour: [],
      alertDate: false,
      activeLoading: false,
    };
  },
  mounted() {
    this.$API.get("indoormanhour").then((result) => {
      console.log("indoormanhour", result);
      result.data.result.forEach((element) => {
        let subDate = element.date.substring(0, 10);
        // console.log("subDate",subDate)

        this.resultIndoorManHour.push({
          date: subDate,
          id: element.id,
          target: element.target,
          username: element.username,
        });
      });

      // console.log("this.resultIndoorManHour", this.resultIndoorManHour);
      // this.resultIndoorManHour.sort(function (a, b) {
      //   a = a.date.split("-");
      //   b = b.date.split("-");
      //   return a[2] - b[2] || a[1] - b[1] || a[0] - b[0];
      // });
      // console.log("this.resultIndoorManHour", this.resultIndoorManHour);
    });
    this.$API.get("indoortag/manhour").then((result) => {
      console.log("indoortag/manhour", result);

      this.resultIndoorTagManHour = result.data;
      this.resultIndoorTagManHour.sort(function (a, b) {
        a = a.date.split("-");
        b = b.date.split("-");
        return a[2] - b[2] || a[1] - b[1] || a[0] - b[0];
      });

      for (var i = 0; i < result.data.length; i++) {
        let obj = result.data[i];
        console.log(obj);
        if (obj.manhour != null) {
          let payload = { date: obj.date, manhour: obj.manhour };
          this.totalManhorExport.push(payload);
          this.totalManhour.push(obj.manhour);
          this.dateManhour.push(obj.date);
          payload = {};
          // console.log(this.totalManhorExport);
        }
      }
      // console.log("this.resultIndoorTagManHour", this.resultIndoorTagManHour);
    });
    this.$API.get("indoortaglog/CA9B4020590E").then((result) => {
      console.log("indoortaglog", result);
    });

    // this.dataChart();
    this.dataChartasync();
  },
  methods: {
    openLoading() {
      this.activeLoading = true;
      this.$vs.loading({
        type: "radius",
      });
      setTimeout(() => {
        this.activeLoading = false;
        this.$vs.loading.close();
      }, 3000);
    },
    openPopupCreateManhourGraph() {
      this.targetValue = 0;
      this.targetDatevalue = "";
      this.$refs["my-modal-createManhour"].show();
    },
    setManhourGraph() {
      this.$refs["my-modal-setManhour"].show();
      this.dataMergeManHour = [];
      this.resultIndoorManHour.forEach((element) => {
        this.resultIndoorTagManHour.forEach((element2) => {
          if (element.date === element2.date) {
            if (element2.manhour) {
              this.dataMergeManHour.push({
                indoorManHour: {
                  date: element.date,
                  id: element.id,
                  target: element.target,
                  username: element.username,
                },
                indoorTagManHour: {
                  date: element2.date,
                  manhour: element2.manhour,
                },
              });
            } else {
              this.dataMergeManHour.push({
                indoorManHour: {
                  date: element.date,
                  id: element.id,
                  target: element.target,
                  username: element.username,
                },
                indoorTagManHour: {
                  date: element2.date,
                  manhour: 0,
                },
              });
            }
          }
        });
      });
    },
    ClosePopupCreateManhourGraph() {
      this.$refs["my-modal-createManhour"].hide();
    },
    ClosePopupSetManhourGraph() {
      this.$refs["my-modal-setManhour"].hide();
    },
    SaveCreateManhourGraph() {
      if (this.targetDatevalue) {
        this.openLoading();
        this.alertDate = false;
        const data = {
          target: this.targetValue,
          date: this.targetDatevalue,
        };
        this.$API
          .post("indoormanhour/create", data)
          .then((res) => {
            if (res.status === 400) {
              alert("SAVE ERROR");
            } else {
              location.reload();
              this.$refs["my-modal-createManhour"].hide();
            }
          })
          .catch((err) => {
            return err.response;
          });
      } else {
        this.alertDate = true;
      }
    },
    SaveSetManhourGraph() {
      // console.log(this.dataMergeManHour);
      this.openLoading();
      let count = 0;
      const length = this.dataMergeManHour.length;
      this.dataMergeManHour.forEach((element) => {
        count += 1;
        const data = {
          id: element.indoorManHour.id,
          target: element.indoorManHour.target,
        };
        this.$API
          .put("indoormanhour/update", data)
          .then((res) => {
            if (length === count) {
              this.$refs["my-modal-setManhour"].hide();
              location.reload();
              return res;
            }
          })
          .catch((err) => {
            return err.response;
          });
      });
    },
    exportXLSX() {
      // console.log(this.totalManhorExport);
      const dataWS = XLSX.utils.json_to_sheet(this.totalWorker);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "Total_Manhour_Export.xlsx");
    },
    exportPDF() {
      let pdfRef = this.$refs.pdf;
      html2canvas(pdfRef).then((canvas) => {
        let pdfImage = canvas.toDataURL();
        let pdf = new jsPDF();
        pdf.addImage(pdfImage, "PNG", 0, 20, 200, 50);
        pdf.save("Total_Manhour_Export.pdf");
      });
    },
    dataChart() {
      // manage data chart bar
      this.selectLoop =
        this.select1 == "Month" ? 30 : this.select1 == "Week" ? 7 : 1;
      // console.log(this.selectLoop);
      // console.log(this.select1);

      // console.log(moment().subtract(30, "days"));

      this.yValue = Array.from({ length: this.selectLoop }, (v, i) => {
        return 0;
      });

      this.xValue = Array.from({ length: this.selectLoop }, (v, i) => {
        return moment()
          .subtract(this.selectLoop - (i + 1), "days")
          .format("YYYY-MM-DD");
      });

      console.log("yValue", this.yValue, this.xValue);

      this.$API.get("indoortag").then((result) => {
        console.log("indoortag", result);
        for (let i = 0; i < result.data.length; i++) {
          const element = result.data[i];
          this.$API.get("indoortaglog/" + element.mac).then((result) => {
            console.log("indoortaglog/", result.data[0]);
            // console.log(
            //   moment(result.data[0].firstdate).format("MMMM Do YYYY, h:mm:ss a")
            // );
            // console.log(result.data);
            for (let j = 0; j < this.selectLoop; j++) {
              for (let k = 0; k < result.data.length; k++) {
                if (result.data[k].firstdate != null) {
                  // const el = result.data[k].firstdate.split("T")[0];
                  const el = moment(result.data[k].firstdate).format(
                    "YYYY-MM-DD"
                  );

                  // console.log(moment(result.data[k].firstdate).format("YYYY-MM-DD"));

                  console.log(el);
                  if (this.xValue[j] == el) {
                    this.yValue[this.selectLoop - (j + 1)]++;
                  }
                }
              }
            }
            console.log("yValue", this.yValue, this.xValue);
            // BarChart.data.labels = this.xValue;
            // BarChart.data.datasets = [
            //   {
            //     label: "Total Manhour",
            //     backgroundColor: "#4caf50",
            //     data: this.yValue,
            //   },
            // ];
            // BarChart.update();
          });
        }
      });
    },
    async dataChartasync() {
      this.totalWorker = [];
      this.selectLoop =
        this.select1 == "Month" ? 30 : this.select1 == "Week" ? 7 : 1;

      let y = Array.from({ length: this.selectLoop }, (v, i) => {
        return 0;
      });

      let x = Array.from({ length: this.selectLoop }, (v, i) => {
        return moment()
          .subtract(this.selectLoop - (i + 1), "days")
          .format("YYYY-MM-DD");
      });

      // call num of tag
      let indoortag = await this.$API.get("indoortag");
      console.log("async indoortag", indoortag);
      if (indoortag.status == 200) {
        for (let i = 0; i < indoortag.data.length; i++) {
          const element = indoortag.data[i];
          // call log by tag
          let indoortaglog = await this.$API.get("indoortaglog/" + element.mac);
          if (indoortaglog.status == 200) {
            console.log("async indoortaglog/", indoortaglog);
            for (let j = 0; j < this.selectLoop; j++) {
              for (let k = 0; k < indoortaglog.data.length; k++) {
                if (indoortaglog.data[k].firstdate != null) {
                  // const el = result.data[k].firstdate.split("T")[0];
                  const el = moment(indoortaglog.data[k].firstdate).format(
                    "YYYY-MM-DD"
                  );

                  // count worker each day
                  if (x[j] == el) {
                    // console.log(x[j] ,el);
                    y[j]++;
                    break;
                  }
                }
              }
            }
          }
        }
        this.xValue = x;
        this.yValue = y;
        console.log("yValue", this.yValue, this.xValue);
        for (let i = 0; i < this.xValue.length; i++) {
          this.totalWorker.push({
            date: this.xValue[i],
            "num of worker": this.yValue[i],
          });
        }
        console.log("this.totalWorker", this.totalWorker);

      }
    },
  },
};
</script>

<style lang="scss" scoped>
.borderR {
  border-radius: 20px;
}
</style>